/* Drug-Free mobile hero — carousel crossfade (arrows + thumbnails) plus an Add to Cart
   button that submits the *shared* product form from sections/main-product-hero.liquid
   instead of owning its own. See the comment at the top of
   sections/product-drug-free-hero.liquid for why: that shared form is also what the bundle
   option cards further down the page update, so this stays in sync with that choice. */
(() => {
  document.querySelectorAll('[data-dfh-carousel]').forEach((root) => {
    const slides = Array.from(root.querySelectorAll('[data-dfh-slide]'));
    const prevButton = root.querySelector('[data-dfh-prev]');
    const nextButton = root.querySelector('[data-dfh-next]');
    const status = root.querySelector('[data-dfh-status]');
    const thumbs = Array.from(document.querySelectorAll('[data-dfh-thumb]'));
    if (slides.length < 2) return;

    let activeIndex = 0;

    function setActive(index) {
      const clamped = Math.max(0, Math.min(slides.length - 1, index));
      if (clamped === activeIndex) return;
      activeIndex = clamped;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === activeIndex);
        slide.setAttribute('aria-hidden', i === activeIndex ? 'false' : 'true');
      });
      thumbs.forEach((thumb, i) => {
        const isActive = i === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
      if (prevButton) prevButton.disabled = activeIndex === 0;
      if (nextButton) nextButton.disabled = activeIndex === slides.length - 1;
      if (status) status.textContent = `Slide ${activeIndex + 1} of ${slides.length}`;
    }

    if (prevButton) prevButton.addEventListener('click', () => setActive(activeIndex - 1));
    if (nextButton) nextButton.addEventListener('click', () => setActive(activeIndex + 1));
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => setActive(index)));
  });

  document.querySelectorAll('[data-dfh-add]').forEach((button) => {
    const spinner = button.querySelector('.loading__spinner');

    button.addEventListener('click', () => {
      const form = document.querySelector('form[data-type="add-to-cart-form"]');
      if (form) form.requestSubmit();
    });

    const realSubmitButton = document.querySelector('.product-form__submit');
    if (realSubmitButton) {
      const syncLoadingState = () => {
        const isLoading =
          realSubmitButton.getAttribute('aria-disabled') === 'true' || realSubmitButton.disabled;
        button.disabled = isLoading;
        if (spinner) spinner.classList.toggle('hidden', !isLoading);
      };
      new MutationObserver(syncLoadingState).observe(realSubmitButton, {
        attributes: true,
        attributeFilter: ['aria-disabled', 'disabled'],
      });
    }
  });

  // Mirrors product-bundle-selector.js's own price sync (it only updates the price
  // display inside the bundle radio's own form) for this section's own price
  // displays, plus swaps the per-bundle promo/note blocks tagged [data-dfh-for].
  function syncFromRadio(radio) {
    if (!radio) return;

    document.querySelectorAll('[data-dfh-for]').forEach((el) => {
      el.hidden = el.dataset.dfhFor !== radio.value;
    });

    const buttonPriceEl = document.querySelector('[data-dfh-price]');
    if (buttonPriceEl) {
      const nowEl = buttonPriceEl.querySelector('.now');
      if (nowEl) nowEl.textContent = radio.dataset.price || '';
      let wasEl = buttonPriceEl.querySelector('.was');
      if (radio.dataset.comparePrice) {
        if (!wasEl) {
          wasEl = document.createElement('span');
          wasEl.className = 'was';
          buttonPriceEl.appendChild(wasEl);
        }
        wasEl.textContent = radio.dataset.comparePrice;
      } else if (wasEl) {
        wasEl.remove();
      }
    }

    const metaPriceEl = document.querySelector('[data-dfh-meta-price]');
    if (metaPriceEl) {
      const currentEl = metaPriceEl.querySelector('.drug-free-hero__price-current');
      if (currentEl) currentEl.textContent = radio.dataset.price || '';
      let compareEl = metaPriceEl.querySelector('.drug-free-hero__price-compare');
      if (radio.dataset.comparePrice) {
        if (!compareEl) {
          compareEl = document.createElement('s');
          compareEl.className = 'drug-free-hero__price-compare';
          metaPriceEl.insertBefore(compareEl, currentEl);
        }
        compareEl.textContent = radio.dataset.comparePrice;
      } else if (compareEl) {
        compareEl.remove();
      }
    }
  }

  document.addEventListener('change', (event) => {
    const radio = event.target.closest('.vr-opt__radio');
    if (radio) syncFromRadio(radio);
  });

  syncFromRadio(document.querySelector('.vr-opt__radio:checked'));
})();
